<template lang="pug">
  .input-img(:disabled="disabled")
    b-img.img.b-1(rounded, :style="image_style", :class="src ? image_filter : ''", blank-color="#ddd", :blank="error || !src", :src="src", @error="error = true", @click="disabled ? '' : $emit('click')", :disabled="disabled")
    trash-2-icon.text-white.action-icon(v-if="!editable && src", :style="icon_style")
    edit-icon.text-white.action-icon(v-else, :style="icon_style")
</template>

<script>
  export default {
    data () {
      return {
        error: false
      }
    },
    props: {
      size: {
        type: String,
        default: 'default'
      },
      src: {
        type: String,
        default: ''
      },
      editable: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      image_style () {
        let style = {},
          size = 70

        switch (this.size) {
          case 'xxs':
            size = 30
            break
          case 'xs':
            size = 40
            break
          case 'sm':
            size = 50
            break
          case 'md':
            size = 60
            break
          case 'lg':
            size = 80
            break
          case 'xl':
            size = 100
            break
        }

        style.width = `${size}px`
        style.height = `${size}px`

        return style
      },
      image_filter () {
        return this.editable ? 'blue' : 'red'
      },
      icon_style () {
        let style = {},
          size = 70

        switch (this.size) {
          case 'xxs':
            size = 30
            break
          case 'xs':
            size = 40
            break
          case 'sm':
            size = 50
            break
          case 'md':
            size = 60
            break
          case 'lg':
            size = 80
            break
          case 'xl':
            size = 100
            break
        }

        style.width = `${size/2}px`
        style.height = `${size/2}px`
        style.right = `${size/4}px`
        style.top = `${size/4}px`

        return style
      },
    },
    watch: {
      src (value) {
        this.error = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .input-img {
    position: relative;
    display: inline-block;

    .img {
      object-fit: cover;
      &:not([disabled]):hover {
        cursor: pointer;
        &.red {
          -webkit-filter: invert(40%) grayscale(100%) brightness(40%) sepia(100%) hue-rotate(-50deg) saturate(400%) contrast(2);
          filter: grayscale(100%) brightness(40%) sepia(100%) hue-rotate(-50deg) saturate(600%) contrast(0.8);
        }
        &.blue {
          -webkit-filter: grayscale(100%) brightness(30%) sepia(100%) hue-rotate(-180deg) saturate(700%) contrast(0.8);
          filter: grayscale(100%) brightness(30%) sepia(100%) hue-rotate(-180deg) saturate(700%) contrast(0.8);
        }
      }
    }

    .action-icon {
      position: absolute;
      pointer-events: none;
      display: none;
    }
  }

  .input-img:not([disabled]):hover {
    .action-icon {
      display: inline-block;;
    }
  }

  .indicator-mask {
    mask-image: url("/mask.svg");
    mask-size: 100% 100%;
  }
</style>
